// //C:\Users\Anish\xpr_survey\XPRSuvey-App\src\Components\HR\Services\CompanyServices.js
import api from "../../axios";

export const getAssignedAssessmentListByHRUserID = () => api.post("/api/XPRS_Company/XPRSCompany/GetAssignedAssessmentListByHRUserID");

export const getAssignedAssessmentQuestions = (SurveyUid) => api.post("/api/XPRS_Company/XPRSCompany/AssessmentQuestions",SurveyUid);

export const getChannelsForCompany = (SurveyUid) => api.get("/api/XPRS_Company/XPRSCompany/Channel");

export const CreateResponders = (assessmentUID, excelFile,deadline) => {
  const formData = new FormData();
  
  formData.append("AssessmentUID", assessmentUID);
  formData.append("Excel", excelFile);
  formData.append("Deadline", deadline);

  return api.post("/api/XPRS_Company/XPRSCompany/CreateResponders", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const CreateSingleResponder = (payload) => {
  return api.post("/api/XPRS_Company/XPRSCompany/CreateResponder", payload);
};

export const GetAssessmentResponders = (assessmentUID) => {
  return api.get(`/api/XPRS_Company/XPRSCompany/SurveyResponders/${assessmentUID}`);
};

export const GetAssessmentReportDetails = () => {
  return api.post(`/api/XPRS_Company/XPRSCompany/GetReportSurveyDetails`);
};


export const GetExcelReport = (assessmentID, responderUID) => {
  return api.post("/api/XPRS_Company/XPRSCompany/ExcelReportRequest",{ AssessmentID: assessmentID, ResponderUID: responderUID },
    { responseType: "blob" }
  );
};

export const GetBulkExcelReport = (responderKeys) => {
  return api.post("/api/XPRS_Company/XPRSCompany/GetBulkExcelReport",{ ResponderKeys: responderKeys },
    { responseType: "blob" }
  );
};

export const getCompanyLogo = async () => {
  const response = await api.post(
    "/api/XPRS_Company/XPRSCompany/GetCompanyLogo",
    {},
    { responseType: "blob" }
  );
  return response.data; // Blob
};


export const getAssessmentTemplates = (payload) =>
  api.post("/api/XPRS_Company/XPRSCompany/GetAssessmentTemplates", payload);

export const createAssessmentTemplate = (payload) =>
  api.post("/api/XPRS_Company/XPRSCompany/CreateAssessmentTemplate", payload);

export const CreateRemainders = (payload) => {
    return api.post("/api/XPRS_Company/XPRSCompany/CreateRemainders", payload);
};

export const getCompanyName = async () => {
    const response = await api.get(
        "api/XPRS_Company/XPRSCompany/GetCompanyName"
    );

    return response.data;
};

export const getClientDashboardData = () => {
  return api.get("api/XPRS_Company/XPRSCompany/ClientDashBoardData");
};

export const GetCompanyHRUserList = (AssessmentUID) => {
  return api.get(`api/XPRS_Company/XPRSCompany/GetCompanyHRUserList/${AssessmentUID}`);
};

export const AssignAssessmentToCompanyHr = (payload) => {
    return api.post("api/XPRS_Company/XPRSCompany/AssignAssessmentToCompanyHr", payload);
};

export const UnassignAssessment = (payload) => {
    return api.post("api/XPRS_Company/XPRSCompany/UnassignAssessment", payload);
};

export const ExtendResponderDeadline = (payload) =>{  
    return api.post("api/XPRS_Company/XPRSCompany/ExtendResponderDeadline", payload);
};


  export const getDashboardGraphFilterData = (payload) =>
       api.get("api/XPRS_Company/XPRSCompany/GetDashboardGraphFilterData", {
           params: payload
       });